import { render, staticRenderFns } from "./app-service-level-rank.vue?vue&type=template&id=3481cc53&scoped=true&"
import script from "./js/app-service-level-rank.js?vue&type=script&lang=js&"
export * from "./js/app-service-level-rank.js?vue&type=script&lang=js&"
import style0 from "./app-service-level-rank.vue?vue&type=style&index=0&id=3481cc53&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3481cc53",
  null
  
)

export default component.exports